/**
 * Helpers for public share URLs.
 *
 * The public app is served under `/app/*`. Managers copy these links and
 * paste them into WhatsApp — we always want an ABSOLUTE URL so it works
 * from any device.
 */

function _origin() {
  if (typeof window === "undefined") return "";
  // In production this is https://app.angiolini.kz; in preview it is the
  // preview URL. Either way `location.origin` gives us the right host.
  return window.location.origin;
}

/** Direct catalog card link — public, works without login.
 *  Uses `/preview/product/:id` (not `/app/catalog/:id`) so visitors from
 *  WhatsApp see the card without hitting the client-app auth gate. */
export function productShareUrl(productId, managerId) {
  const base = `${_origin()}/preview/product/${productId}`;
  return managerId ? `${base}?ref=${managerId}` : base;
}

/** Curated bundle short link (24h TTL). Token is unique per bundle. */
export function bundleShareUrl(token) {
  return `${_origin()}/share/${token}`;
}
